import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { esqueciSenha } from "../services/api";

// Só caminho interno — nunca "//outro-site".
const interno = (v) => (v && v.startsWith("/") && !v.startsWith("//") ? v : null);

export default function EsqueciSenhaPage() {
  const [params] = useSearchParams();
  // De onde a pessoa veio (a vaga): segue junto para o login e para o cadastro, senão ela volta à home.
  const redirect = interno(params.get("redirect"));
  const sufixo = redirect ? `redirect=${encodeURIComponent(redirect)}` : "";
  const [email, setEmail] = useState("");
  const [enviado, setEnviado] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);

  const enviar = async (e) => {
    e.preventDefault();
    setErro(null); setCarregando(true);
    try {
      await esqueciSenha(email.trim());
      setEnviado(true);
    } catch (err) {
      setErro(err.message || "Falha ao solicitar a redefinição.");
    } finally {
      setCarregando(false);
    }
  };

  const inputCls = "w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:ring-2 focus:ring-primary outline-none";

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-4 py-10">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h1 className="text-xl font-bold text-text">Esqueci minha senha</h1>

          {enviado ? (
            <div className="mt-4">
              <p className="rounded-lg bg-green-50 border border-green-200 text-green-800 px-3 py-3 text-sm">
                Se este e-mail estiver cadastrado, enviamos um link para redefinir a senha. Verifique sua caixa de entrada (e o spam). O link vale por 1 hora.
              </p>
              {/* 🚨 QUEM NÃO TEM CONTA NÃO RECEBE NADA — e não pode ser avisado (diria a qualquer um quais e-mails
                  existem aqui). Três pessoas da vaga de Supervisor Administrativo da Reframax (10/09/2026) foram
                  do login para cá, não receberam e-mail e desistiram: muito provavelmente nunca tinham criado conta.
                  O caminho para o cadastro fica aqui, sem revelar se o e-mail existe. */}
              <div className="mt-3 rounded-lg bg-amber-50 border border-amber-200 px-3 py-3 text-sm text-amber-900">
                <p><strong>Não chegou em 2 minutos?</strong> Confira o spam. Se mesmo assim nada chegar, talvez este e-mail ainda não tenha conta no eaiRH — criar leva 1 minuto.</p>
                <Link to={`/entrar?cadastro=1${sufixo ? `&${sufixo}` : ""}`}
                  className="inline-block mt-2 rounded-lg bg-orange-600 hover:bg-orange-700 text-white font-semibold px-4 py-2">
                  Criar minha conta
                </Link>
              </div>
              <Link to={`/entrar${sufixo ? `?${sufixo}` : ""}`} className="inline-block mt-4 text-sm text-primary font-semibold hover:underline">← Voltar para o login</Link>
            </div>
          ) : (
            <form onSubmit={enviar} className="mt-4 space-y-3">
              <p className="text-sm text-gray-600">Informe o e-mail da sua conta. Enviaremos um link para você criar uma nova senha.</p>
              {erro && <p role="alert" className="rounded-lg bg-red-50 border border-red-200 text-red-700 px-3 py-2 text-sm">{erro}</p>}
              <input type="email" required className={inputCls} aria-label="E-mail da sua conta" placeholder="seu@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
              <button type="submit" disabled={carregando || !email.trim()}
                className="w-full bg-primary hover:opacity-90 disabled:opacity-60 text-white font-bold py-2.5 rounded-lg">
                {carregando ? "Enviando..." : "Enviar link de redefinição"}
              </button>
              <Link to={`/entrar${sufixo ? `?${sufixo}` : ""}`} className="block text-center text-sm text-gray-500 hover:underline">Voltar para o login</Link>
              <p className="text-center text-xs text-gray-500">
                Ainda não tem conta? <Link to={`/entrar?cadastro=1${sufixo ? `&${sufixo}` : ""}`} className="text-primary font-semibold hover:underline">Criar agora</Link>
              </p>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
